import type { Static } from 'runtypes';
import { Literal, Record, String, Number } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const AiShorthandRejectedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_SHORTHAND_REJECTED),
    nodeId: Number,
    originalText: String,
    summaryText: String,
    version: Literal(1),
  })
);

const AiShorthandRejectedEventServerRuntype = AiShorthandRejectedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiShorthandRejectedBrowserEvent = Static<typeof AiShorthandRejectedEventBrowserRuntype>;
type AiShorthandRejectedServerEvent = Static<typeof AiShorthandRejectedEventServerRuntype>;

const isAiShorthandRejectedBrowserEvent = (
  obj: BaseEvent
): obj is AiShorthandRejectedBrowserEvent => {
  return obj.event === 'AI Shorthand Rejected';
};

const isAiShorthandRejectedServerEvent = (
  obj: BaseEvent
): obj is AiShorthandRejectedServerEvent => {
  return obj.event === 'AI Shorthand Rejected';
};

export {
  isAiShorthandRejectedBrowserEvent,
  isAiShorthandRejectedServerEvent,
  AiShorthandRejectedEventBrowserRuntype,
  AiShorthandRejectedEventServerRuntype,
  type AiShorthandRejectedBrowserEvent,
  type AiShorthandRejectedServerEvent,
};
